export const FILTER = 'FILTER';
export const LOAD_UNMATCHED_QUEUE = 'LOAD_UNMATCHED_QUEUE';
export const LOADING_UNMATCHED_QUEUE = 'LOADING_UNMATCHED_QUEUE';

export const COLUMNS_LOCAL_STORAGE_KEY = 'settlementsexceptionQueueColumns';
export const COLUMNS_WIDTH = 160;
